(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.bsb-fp').forEach(initSection);
  }

  function initSection(section) {
    if (typeof Swiper === 'undefined') return;

    const el = section.querySelector('.swiper');
    if (!el || el.dataset.bsbFpInitialized) return;
    el.dataset.bsbFpInitialized = 'true';

    const wrap = el.closest('.bsb-fp__carousel-wrap');
    const prevBtn = wrap?.querySelector('[data-swiper-prev]');
    const nextBtn = wrap?.querySelector('[data-swiper-next]');
    const slidesDesktop = parseFloat(el.dataset.slidesDesktop) || 4;
    const slidesMobile = parseFloat(el.dataset.slidesMobile) || 1.5;

    new Swiper(el, {
      slidesPerView: slidesMobile,
      spaceBetween: 14,
      threshold: 5,
      slideToClickedSlide: false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {
        769: {
          slidesPerView: slidesDesktop,
          spaceBetween: 14,
          pagination: { enabled: false }
        }
      },
      grabCursor: true,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'bsb-fp__arrow--disabled'
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
